import { css } from '@emotion/css';
import { Divider, MenuItem, Select, TextField, InputAdornment } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import {
  ArrowDropDown,
  Business,
  FindInPage as FindInPageIcon,
  MenuBookRounded,
  Room,
  Search,
  TuneRounded as Tune,
} from '@material-ui/icons';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import { Autocomplete } from '@material-ui/lab';
import { getInfosIndividual, getJobs, getOffresMap } from '@webapps/business';
import { getProfilePresentation } from '@webapps/business';
import {
  getBusinessPartners,
  getBusinesses,
  getBusinessesDomains,
  getFormationsMap,
  getInfosAccountRestricted,
  getSchools,
  getSchoolsPartners,
  getTrainingDomains,
} from '@webapps/business';
import {
  FormikAutocompletePx,
  FormikTextFieldPx,
  FormikTextField50,
  ModalSideBar,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import { ROUTES_PATH } from 'config/constants';
import { min } from 'date-fns';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';

import Mapimg from '../../../../../libs/styles/src/lib/assets/images/map';
import DetailsFormation from './Components/Formation/Details';
import FiltersFormation from './Components/Formation/FiltersFormation';
import Formations from './Components/Formation/Formations';
import DetailsOffre from './Components/Offre/Details';
import FiltersOffre from './Components/Offre/FiltersOffre';
import Offres from './Components/Offre/Offres';
import CitySearchDropdown from 'components/CitySearchDropdown/index';

const MyMap = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const location = useLocation();

  const { idUser, profile } = useAuth();
  const { push } = useRouter();
  const { data: { completeRate } = {} } = useQuery(getProfilePresentation, {
    key: 'studentCompleteRate',
    variables: { id: idUser },
  });

  const { data: domains = [], isLoading: domainLoading } = useQuery(
    getBusinessesDomains,
    {
      key: 'domainsBusiness',
    }
  );

  const {
    data: { content: trainingDomains = [] } = {},
    isLoading: trainingDomainsLoading,
  } = useQuery(getTrainingDomains, {
    key: 'trainingDomainsMap',
  });

  const { searchParams, updateSearchParams } = useRouter();

  const filterSchema = yup.object().shape({
    keyword: yup.string(),
    businesses: yup.array(),
    cities: yup.string(),
    // cities: yup.array().of(yup.string()),
    contractTypes: yup.array(),
    degreeLevels: yup.array(),
    sectors: yup.array(),
    sector: yup.object().shape({
      id: yup.string(),
    }),
    telework: yup.array(),
    trainingTypes: yup.array(),
    trainingDomains: yup.array(),
    schools: yup.array(),
    studyPlans: yup.array(),
  });

  const {
    businesses: businessesParams,
    businessesExternals: businessesExternalsParams,
    cities: citiesParams,
    contracts: contractsParams,
    degrees: degreesParams,
    domains: domainsParams,
    keyword: keywoardParams,
    sectors: sectorsParams,
    telework: teleworkParams,
    /*cities: citiesParams,
    degrees: degreesParams,
    domains: domainsParams,
    keywordTraining: keywoardParams,*/
    schools: schoolsParams,
    studyPlans: studyPlansParams,
    trainingTypes: trainingTypesParams,
  } = searchParams;
  const [keywordRequest, setKeywordRequest] = useState(keywoardParams || '');
  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', keywordRequest],
    variables: { keyword: keywordRequest || '' },
  });

  const [businessesRequest, setBusinessesRequest] = useState(businessesParams || '');
  const [businessesExternalsRequest, setbusinessesExternalsRequest] = useState(businessesExternalsParams || location?.state?.businessExternal || '');
  const [citiesRequest, setCitiesRequest] = useState(citiesParams || '');
  const [contractsRequest, setContractsRequest] = useState(contractsParams || '');
  const [degreeLevelsRequest, setDegreeLevelsRequest] = useState(degreesParams || '');
  const [sectorsRequest, setSectorsRequest] = useState(sectorsParams || '');
  const [domainsRequest, setDomainsRequest] = useState(domainsParams || '');
  const [teleworkRequest, setTeleworkRequest] = useState(teleworkParams || '');
  const [schoolsRequest, setSchoolsRequest] = useState(schoolsParams || '');
  const [studyPlansRequest, setStudyPlansRequest] = useState(
    studyPlansParams || ''
  );
  const [trainingTypesRequest, setTrainingTypesRequest] = useState(
    trainingTypesParams || ''
  );

  const formik = useFormik({
    initialValues: {
      keyword: keywoardParams || '',
      businesses: businessesParams?.split(',') || '',
      businessesExternals: businessesExternalsParams?.split(',') || '',
      cities: citiesParams || '',
      contractTypes: contractsParams?.split(',') || '',
      degreeLevels: degreesParams?.split(',') || '',
      sectors: sectorsParams?.split(',') || '',
      domains: domainsParams || '',
      telework: teleworkParams?.split(',') || '',
    },
    enableReinitialize: true,
    validationSchema: filterSchema,
    onSubmit: ({
      businesses,
      businessesExternals,
      cities,
      contractTypes,
      degreeLevels,
      domains,
      keyword,
      sectors,
      telework,
    }) => {
      setKeywordRequest(keyword);
      setBusinessesRequest(businesses?.toString());
      setbusinessesExternalsRequest(businessesExternals?.toString());
      setCitiesRequest(cities);
      setContractsRequest(contractTypes?.toString());
      setDegreeLevelsRequest(degreeLevels?.toString());
      setSectorsRequest(sectors?.toString());
      setDomainsRequest(domains);
      setTeleworkRequest(telework?.toString());
      updateSearchParams({
        keyword,
        businesses: businesses?.toString(),
        businessesExternals: businessesExternals?.toString(),
        cities,
        contracts: contractTypes?.toString(),
        degrees: degreeLevels?.toString(),
        sectors: sectors?.toString(),
        domains: domains,
        telework: telework?.toString(),
      });
      setPage(1);
    },
  });

  const formikFormations = useFormik({
    initialValues: {
      keyword: keywoardParams || '',
      schools: schoolsParams?.split(',') || '',
      cities: citiesParams || '',
      studyPlans: studyPlansParams?.split(',') || '',
      degrees: degreesParams?.split(',') || '',
      domains: domainsParams || '',
      trainingTypes: trainingTypesParams?.split(',') || '',
    },
    enableReinitialize: true,
    validationSchema: filterSchema,
    onSubmit: ({
      cities,
      degrees,
      domains,
      keyword,
      schools,
      studyPlans,
      trainingTypes,
    }) => {
      setKeywordRequest(keyword);
      setSchoolsRequest(schools?.toString());
      setCitiesRequest(cities);
      setStudyPlansRequest(studyPlans?.toString());
      setDegreeLevelsRequest(degrees?.toString());
      setDomainsRequest(domains);
      setTrainingTypesRequest(trainingTypes?.toString());
      updateSearchParams({
        keywordTraining: keyword,
        schools: schools?.toString(),
        cities,
        studyPlans: studyPlans?.toString(),
        degrees: degrees?.toString(),
        domains: domains,
        trainingTypes: trainingTypes?.toString(),
      });
      setPage(1);
    },
  });

  const resetParamsUrl = () => {
    updateSearchParams({
      keyword: '',
      businesses: '',
      cities: '',
      contracts: '',
      degrees: '',
      sectors: '',
      domains: '',
      telework: '',
      schools: '',
      studyPlans: '',
      trainingTypes: '',
      keywordTraining: '',
    });
  };

  const [value, setValue] = useState(
    location?.state === 'souscriptionBusiness' ||
      location?.state === 'business' ||
      !location?.state
      ? '1'
      : '2'
  );
  const intl = useIntl();

  const [filterOfferOpened, setFilterOfferOpened] = useState(false);

  const handleFilterOfferClose = () => {
    setFilterOfferOpened(false);
  };

  const handleFilterOfferOpen = () => {
    setFilterOfferOpened(true);
  };

  const [filterFormationOpened, setFilterFormationOpened] = useState(false);

  const handleFilterFormationClose = () => {
    setFilterFormationOpened(false);
  };

  const handleFilterFormationOpen = () => {
    setFilterFormationOpened(true);
  };

  const [page, setPage] = useState(1);

  const { data: { content: partnersAccepted = [] } = {}, refetch: refetchSchoolAccepted } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersAccepted', idUser],
      variables: {
        id: idUser,
        type: 'accepted',
        page: 0,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: partnersAcceptedBusiness = [] } = {}, refetch: refetchBusinessAccepted } = useQuery(
    getBusinessPartners,
    {
      key: ['businesssPartnersAccepted', idUser],
      variables: {
        id: idUser,
        type: 'accepted',
        page: 0,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: partnersRequested = [] } = {}, refetch: refetchSchoolRequested } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersRequest', idUser],
      variables: {
        id: idUser,
        type: 'requested',
        page: 0,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: partnersRequestedBusiness = [] } = {}, refetch: refetchBusinessRequested } = useQuery(
    getBusinessPartners,
    {
      key: ['businessPartnersRequest', idUser],
      variables: {
        id: idUser,
        type: 'requested',
        page: 0,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const {
    load: loading,
    data: { content: partnersReceivedBusiness = [] } = {},
    isFetching: isFetchingBusiness,
    refetch: refetchBusinessReceived,
  } = useQuery(getBusinessPartners, {
    key: ['businessPartnersReceived', page + idUser],
    variables: {
      id: idUser,
      type: 'received',
      page: 0,
      size: 1000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    data: { content: partnersReceived = [] } = {},
    refetch: refetchSchoolReceived,
  } = useQuery(getSchoolsPartners, {
    key: ['schoolsPartnersReceived', page + idUser],
    variables: {
      id: idUser,
      type: 'received',
      page: 0,
      size: 1000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: accountInfos = {} } = useQuery(getInfosAccountRestricted, {
    key: ['accountInfos'] + idUser,
    variables: { id: idUser },
  });

  const {
    status: load,
    data: { content: offres = [], totalElements } = {},
    isFetching,
    refetch: refetchOffres,
  } = useQuery(getOffresMap, {
    key: [
      'offresCart',
      businessesRequest +
      businessesExternalsRequest +
      keywordRequest +
      citiesRequest +
      contractsRequest +
      degreeLevelsRequest +
      sectorsRequest +
      domainsRequest +
      teleworkRequest +
      idUser +
      page,
    ],
    variables: {
      keyword: keywordRequest,
      businesses: businessesRequest,
      businessesExternals: businessesExternalsRequest,
      cities: citiesRequest,
      contracts: contractsRequest,
      degreeLevels: degreeLevelsRequest,
      sectors: sectorsRequest,
      domains: domainsRequest,
      telework: teleworkRequest,
      accountId: idUser,
      page: page - 1,
      size: 10,
      status: 'opened',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    status: loadFormations,
    data: {
      content: formations = [],
      totalElements: totalElementsFormations,
    } = {},
    isFetchingFormations,
  } = useQuery(getFormationsMap, {
    key: [
      'formationsCartjkhkj',
      schoolsRequest +
      keywordRequest +
      citiesRequest +
      studyPlansRequest +
      degreeLevelsRequest +
      domainsRequest +
      trainingTypesRequest +
      page,
    ],
    variables: {
      keyword: keywordRequest,
      schools: schoolsRequest,
      cities: citiesRequest,
      studyPlans: studyPlansRequest,
      degrees: degreeLevelsRequest,
      domains: domainsRequest,
      trainingTypes: trainingTypesRequest,
      page: page - 1,
      size: 10,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  console.log("🚀 ~ MyMap ~ formations:", formations)

  if (profile === 'INDIVIDUAL' && completeRate < 100) {
    push(ROUTES_PATH.STUDENT_PROFIL);
  }

  const [info, setInfo] = useState({});

  useEffect(() => {
    if (offres?.length) {
      setInfo(offres[0]);
    }
  }, [offres?.length]);

  const MENUS = [
    { id: 'formation', label: 'Formation' },
    { id: 'emploi', label: 'Emploi' },
  ];

  const {
    data: userInfo = {},
    isLoadingProfilInfo,
    refetch,
  } = useQuery(getInfosIndividual, {
    key: ['profilInfoID', idUser],
    variables: { id: idUser },
  });

  const [choice, setChoice] = useState('emploi');

  const [contentType, setContentType] = useState('emploi');

  const handleChange = (v) => {
    resetParamsUrl();
    formik.handleSubmit();
    formikFormations.handleSubmit();
    refetchBusinessAccepted();
    refetchBusinessRequested();
    refetchBusinessReceived();
    refetchSchoolAccepted();
    refetchSchoolRequested();
    refetchSchoolReceived();

    setContentType(v.props.value.id);
    setChoice(v.props.value.id);
  };

  const handleRefetch = () => {
    refetchBusinessAccepted();
    refetchBusinessRequested();
    refetchBusinessReceived();
    refetchSchoolAccepted();
    refetchSchoolRequested();
    refetchSchoolReceived();
    refetchOffres();
  }


  return (
    <>

      <Grid
        container
        className={cx(global.containerNoScroll, css({
          display: 'flex',
          justifyContent: 'space-between',
          overflow: 'hidden',
          columnGap: '30px',
          '@media screen and (max-width: 1023px)': {
            height: 'fit-content',
            overflow: 'visible',
            flexDirection: 'row',
            rowGap: '20px',
            padding: '20px',
          },
        }))}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          className={classes.containeroffres}
        >
          <Grid
            container
            style={{
              padding: '20px',
            }}
            className={classes.inputRowGap}
            direction="column"
          >
            <Grid container className={classes.inputColumnGap}>
              <Grid item xs={12} sm>
                <FormikTextFieldPx
                  formik={choice === 'emploi' ? formik : formikFormations}
                  fullWidth
                  label=""
                  onChange={(e, v) => handleChange(v)}
                  select
                  name="menu"
                  borderRadius={6}
                  value={MENUS.find((menu) => menu.id === choice)}
                >
                  {MENUS.map((menu) => (
                    <MenuItem key={menu.id} value={menu}>
                      {menu.label}
                    </MenuItem>
                  ))}
                </FormikTextFieldPx>
              </Grid>
              <Grid item xs>
                <CitySearchDropdown formik={choice === 'emploi' ? formik : formikFormations} />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <FormikTextFieldPx
                  style={{ color: '#5D75A8' }}
                  formik={choice === 'emploi' ? formik : formikFormations}
                  borderRadius={6}
                  fullWidth
                  label={choice === 'emploi' ? <FormattedMessage id="searchLabelPoste" /> : <FormattedMessage id="searchLabelFormation" />}
                  name="keyword"
                  onInputChange={(event, value) => {
                    setKeywordRequest(value);
                  }}
                  variant="outlined"
                  pathValue="label"
                  endAdornment={
                    <InputAdornment position="end">
                      <Search style={{ color: '#5D75A8' }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikAutocompletePx
                  formik={choice === 'emploi' ? formik : formikFormations}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  borderRadius={6}
                  label="Domaines pro."
                  name="domains"
                  options={choice === 'emploi' ? domains : trainingDomains}
                  pathValue="id"
                  value={choice === 'emploi' ?
                    domains.find((domain) => domain.id === formik.values.domains) || null :
                    trainingDomains.find((domain) => domain.id === formikFormations.values.domains) || null
                  }
                // popupIcon={<MenuBookRounded style={{ color: '#5D75A8' }} />}
                />
              </Grid>
            </Grid>
            <Grid container className={classes.inputRowGap}>
              {/* Afficher le contenu en fonction du contentType */}
              {contentType === 'emploi' && (
                <Button
                  fullWidth
                  onClick={handleFilterOfferOpen}
                  variant="outlined"
                  className={css({ borderRadius: 5 })}
                >
                  <Tune style={{ fontSize: '25px', marginRight: spacing(1) }} />
                  <FormattedMessage id="filter" />
                </Button>
              )}
              {contentType === 'formation' && (
                <Button
                  fullWidth
                  onClick={handleFilterFormationOpen}
                  variant="outlined"
                  className={css({ borderRadius: 5 })}
                >
                  <Tune
                    style={{
                      color: '#5A6DA1',
                      fontSize: '25px',
                      marginRight: spacing(1),
                    }}
                  />
                  <FormattedMessage id="filter" />
                </Button>
              )}
              {choice === 'emploi' ? (
                <Button
                  color="primary"
                  fullWidth
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  className={css({ borderRadius: 5 })}
                  variant="contained"
                >
                  <FormattedMessage id="btnSearch" />
                </Button>
              ) : (
                <Button
                  color="primary"
                  fullWidth
                  className={css({ borderRadius: 5 })}
                  onClick={formikFormations.handleSubmit}
                  variant="contained"
                  style={{
                    boxShadow: 'none',
                  }}
                >
                  <FormattedMessage id="btnSearch" />
                </Button>
              )}
            </Grid>
          </Grid>
          <Divider fullWidth />
          <Grid item className={classes.overflow} >
            {/* Afficher le contenu en fonction du contentType */}
            {contentType === 'emploi' && (
              <Offres
                isFetching={isFetching}
                partnersAccepted={partnersAccepted}
                partnersRequested={partnersRequested}
                partnersReceived={partnersReceived}
                handleRefetch={handleRefetch}
                accountInfos={accountInfos}
                load={load}
                offres={offres}
                info={info}
                setInfo={setInfo}
                page={page}
                setPage={setPage}
                totalElements={totalElements}
                userInfo={userInfo}
              />
            )}
            {contentType === 'formation' && (
              <Formations
                isFetching={isFetchingFormations}
                load={loadFormations}
                formations={formations}
                info={info}
                setInfo={setInfo}
                page={page}
                setPage={setPage}
                totalElements={totalElementsFormations}
                formik={formikFormations}
                resetParamsUrl={resetParamsUrl}
                partnersAccepted={partnersAcceptedBusiness}
                partnersRequested={partnersRequestedBusiness}
                partnersReceived={partnersReceivedBusiness}
                handleRefetch={handleRefetch}
                accountInfos={accountInfos}
              />
            )}
          </Grid>
        </Grid>
        <Grid container item xs className={classes.containerdetails}>
          {/* Afficher le contenu en fonction du contentType */}
          {contentType === 'emploi' && (
            <DetailsOffre
              partnersAccepted={partnersAccepted}
              partnersRequested={partnersRequested}
              partnersReceived={partnersReceived}
              accountInfos={accountInfos}
              info={info}
              setInfo={setInfo}
              handleRefetch={handleRefetch}
              userInfo={userInfo}
            />
          )}
          {contentType === 'formation' && (
            <DetailsFormation
              partnersAccepted={partnersAcceptedBusiness}
              partnersRequested={partnersRequestedBusiness}
              partnersReceived={partnersReceivedBusiness}
              accountInfos={accountInfos}
              info={info}
              setInfo={setInfo}
              handleRefetch={handleRefetch}
            />
          )}
        </Grid>
      </Grid>

      <ModalSideBar
        handleClose={handleFilterOfferClose}
        open={filterOfferOpened}
        title="Filtres"
        width="500px"
      >
        <FiltersOffre
          domainsParams={domainsParams}
          formik={formik}
          handleClose={handleFilterOfferClose}
          resetParamsUrl={resetParamsUrl}
          domains={domains}
          domainLoading={domainLoading}
        />
      </ModalSideBar>
      <ModalSideBar
        handleClose={handleFilterFormationClose}
        open={filterFormationOpened}
        title="Filtres"
        width="500px"
      >
        <FiltersFormation
          formik={formikFormations}
          resetParamsUrl={resetParamsUrl}
          handleClose={handleFilterFormationClose}
          trainingDomains={trainingDomains}
          trainingDomainsLoading={trainingDomainsLoading}
        />
      </ModalSideBar>
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '80vh',
    // padding: spacing(3),
    '@media only screen and (max-width:768px)': {
      margin: spacing(3, 2, 2, 2),
      padding: 0,
    },
  },
  containeroffres: {
    borderRadius: '10px',
    background: 'white',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width:1023px)': {
      overflow: 'visible',
    },
  },
  overflow: {
    overflowX: 'hidden',
  },
  inputColumnGap: {
    columnGap: '10px',
    '@media screen and (max-width: 1023px)': {
      rowGap: '10px',
    },
  },
  inputRowGap: {
    rowGap: '10px',
  },
  inputRowGap: {
    rowGap: '10px',
  },
  containerdetails: {
    borderRadius: '10px',
    background: 'white',
    height: '100%',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    '@media only screen and (max-width:1023px)': {
      display: 'none',
    },
  },
});

export default MyMap;
